import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router'
import { cn } from '@/utils/cn'

const FEATURE_KEYS = ['brandFeature1', 'brandFeature2', 'brandFeature3', 'brandFeature4'] as const

export function AuthLayout() {
  const { t } = useTranslation('auth')

  return (
    <div className="min-h-screen bg-background lg:grid lg:grid-cols-2">
      <div className="relative hidden overflow-hidden border-r border-border lg:flex lg:flex-col lg:items-center lg:justify-center">
        <div className="absolute -left-24 -top-24 h-96 w-96 rounded-full bg-brand-green/10 blur-3xl" />
        <div className="absolute -bottom-24 -right-24 h-96 w-96 rounded-full bg-brand-blue/10 blur-3xl" />
        <div className="absolute left-1/2 top-1/2 h-64 w-64 -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand-cyan/5 blur-3xl" />

        <div className="relative z-10 flex w-full max-w-xs flex-col items-center px-8 text-center xl:max-w-sm">
          <span className="text-5xl font-bold tracking-tight xl:text-6xl">
            <span className="text-brand-green">Care</span>
            <span className="text-brand-blue">Flow</span>
          </span>

          <p className="mt-5 text-lg font-semibold leading-snug text-foreground/90">
            {t('brandTagline')}
          </p>

          <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{t('brandSubtitle')}</p>

          <div className="mt-10 flex w-full flex-col gap-3 text-left">
            {FEATURE_KEYS.map((key) => (
              <div key={key} className="flex items-center gap-3">
                <div
                  className={cn(
                    'flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full',
                    'bg-brand-green/20'
                  )}
                >
                  <div className="h-1.5 w-1.5 rounded-full bg-brand-green" />
                </div>
                <span className="text-sm text-foreground/70">{t(key)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="flex min-h-screen flex-col px-6 py-10 lg:min-h-0 lg:items-center lg:justify-center lg:overflow-y-auto lg:px-12 lg:py-12">
        <div className="mb-6 flex justify-center lg:hidden">
          <span className="text-2xl font-bold tracking-tight">
            <span className="text-brand-green">Care</span>
            <span className="text-brand-blue">Flow</span>
          </span>
        </div>
        <div className="flex flex-1 flex-col items-center justify-center lg:flex-none lg:w-full">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
